(function () {
  const containerSelector = '[data-store-availability-container]';
  const modalSelector = '#PickupAvailabilityModal';

  async function renderPickupSection(variantId) {
    const container = document.querySelector(containerSelector);
    if (!container || !variantId) return;

    try {
      const url = `${window.Shopify.routes.root}variants/${variantId}/?section_id=pickup-availability`;
      const res = await fetch(url);
      const text = await res.text();

      const html = new DOMParser().parseFromString(text, 'text/html');
      const section = html.querySelector('.shopify-section');
      if (!section) return;

      // Elimina solo las secciones anteriores, no el contenedor entero
      container.querySelectorAll('.shopify-section').forEach(e => e.remove());

      // Inserta la nueva sección limpia
      container.appendChild(section);

      // Actualiza títulos del modal
      const productTitle = container.dataset.productTitle || '';
      const hasOnlyDefaultVariant = container.dataset.hasOnlyDefaultVariant === 'true';

      const productTitleEl = container.querySelector('[data-pickup-availability-modal-product-title]');
      const variantTitleEl = container.querySelector('[data-pickup-availability-modal-variant-title]');

      if (productTitleEl) productTitleEl.textContent = productTitle;
      if (hasOnlyDefaultVariant && variantTitleEl) variantTitleEl.remove();

      bindModalEvents(container);

      // 💡 Aplicar tienda actual después de renderizar
      const currentStore = getCurrentStore();
      if (currentStore) {
        updatePickupAvailabilityDisplay(currentStore);
      }

    } catch (e) {
      console.error('Pickup availability error:', e);
    }
  }

  function bindModalEvents(scope) {
    const openBtns = scope.querySelectorAll('[data-pickup-availability-modal-open]');
    const modal = scope.querySelector(modalSelector) || document.querySelector(modalSelector);
    const closeBtn = scope.querySelector('.js-modal-close-pickup-availability-modal');

    if (!modal) return;

    // Ensure modal is hidden by default
    modal.classList.remove('is-active');
    modal.setAttribute('hidden', 'hidden');
    modal.style.display = 'flex'; // Keep flex for centering but hidden

    openBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.add('is-active');
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeModal(m) {
      m.classList.remove('is-active');
      m.setAttribute('hidden', 'hidden');
      document.body.style.overflow = '';
    }

    closeBtn && closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeModal(modal);
    });

    modal.addEventListener('click', e => {
      if (e.target === modal) closeModal(modal);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal(modal);
      }
    });
  }

  // Devuelve la tienda actual desde metafields o localStorage
  function getCurrentStore() {
    const customerFavoriteStore = document.querySelector('[data-customer-favorite-store]');
    if (customerFavoriteStore) {
      const metafieldStore = customerFavoriteStore.getAttribute('data-customer-favorite-store');
      if (metafieldStore && metafieldStore !== 'null' && metafieldStore.trim() !== '') {
        return metafieldStore.trim();
      }
    }

    const localStorageStore = localStorage.getItem('favorite_store');
    if (localStorageStore && localStorageStore !== 'null' && localStorageStore.trim() !== '') {
      return localStorageStore.trim();
    }

    return null;
  }

  // Escucha cambio de variante y actualiza con tienda activa
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    // console.log('📦 Variant changed:', variant);
    if (!variant?.id) return;

    renderPickupSection(variant.id);
  });

  // Escucha cambios de tienda (ej: desde modal)
  document.addEventListener('store:changed', function (event) {
    const storeName = event.detail?.storeName;
    if (storeName) {
      updatePickupAvailabilityDisplay(storeName);
    }
  });

  // El nickname llega de sitios distintos (metaobjeto, localStorage, API, DOM) y no
  // siempre viene igual: alguna tienda tiene espacios de sobra en el metaobjeto y el
  // modal guarda el nombre ya recortado. Comparar en crudo hacia que fallase el match y
  // pintaba "Pickup unavailable" aunque la tienda tuviese stock.
  function normalizeStoreName(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function findStoreInfo(scope, storeNickname) {
    const target = normalizeStoreName(storeNickname);
    if (!target) return null;

    const candidates = scope.querySelectorAll('[data-store-pickup-info]');
    for (const el of candidates) {
      if (normalizeStoreName(el.getAttribute('data-store-pickup-info')) === target) {
        return el;
      }
    }
    return null;
  }

  // Abre el selector de tiendas de la cabecera. stores-modal.js lo expone en window;
  // si aun no ha cargado, caemos al propio disparador del header.
  function openStoreSelector() {
    if (typeof window.openStoresModal === 'function') {
      window.openStoresModal();
      return;
    }
    const headerTrigger = document.querySelector('header .row.top .content-store');
    if (headerTrigger) headerTrigger.click();
  }

  function updatePickupAvailabilityDisplay(newStoreNickname) {
    const pickupSection = document.querySelector('[data-pickup-availability-section]');
    if (!pickupSection) return;

    // Limpia siempre el aviso generado en la pasada anterior
    const previousUnavailable = document.querySelector('#unavailablePickupAvailabilityContainer');
    if (previousUnavailable) previousUnavailable.remove();

    pickupSection.querySelectorAll('[data-store-pickup-info]').forEach(info => {
      info.style.display = 'none';
    });

    const activeInfo = findStoreInfo(pickupSection, newStoreNickname);

    if (activeInfo) {
      activeInfo.style.display = 'block';
    } else {
      // La tienda elegida no admite recogida para esta variante: Shopify no devuelve
      // bloque para ella. Mostramos el aviso con un enlace que si funciona.
      const contenedorPrincipal =
        document.querySelector('#shopify-section-pickup-availability .pickup-availability') ||
        pickupSection;

      const wrapper = document.createElement('div');
      wrapper.className = 'pickup-availability-container';
      wrapper.id = 'unavailablePickupAvailabilityContainer';

      const info = document.createElement('div');
      info.className = 'pickup-availability-information-container';
      info.setAttribute('data-store-pickup-info', newStoreNickname);
      info.style.display = 'block';

      const title = document.createElement('p');
      title.className = 'pickup-availability-information__title';
      title.textContent = 'Pickup unavailable at ';
      const storeSpan = document.createElement('span');
      storeSpan.className = 'color-foreground';
      storeSpan.textContent = newStoreNickname;
      title.appendChild(storeSpan);

      const changeStore = document.createElement('button');
      changeStore.type = 'button';
      changeStore.className = 'pickup-availability-information__button product-view-details-link';
      changeStore.setAttribute('data-open-stores-modal', '');
      changeStore.setAttribute('aria-haspopup', 'dialog');
      changeStore.textContent = 'Change store';
      changeStore.addEventListener('click', (e) => {
        e.preventDefault();
        openStoreSelector();
      });

      info.appendChild(title);
      info.appendChild(changeStore);
      wrapper.appendChild(info);
      contenedorPrincipal.insertAdjacentElement('afterbegin', wrapper);
    }

    pickupSection.setAttribute('data-current-store', newStoreNickname);
  }

  window.openStoreSelector = openStoreSelector;
  window.renderPickupSection = renderPickupSection;
  window.updatePickupAvailabilityDisplay = updatePickupAvailabilityDisplay;

  // Al cargar la página
  document.addEventListener('DOMContentLoaded', () => {
    const initialVariantId =
      window?.Shopify?.theme?.product?.selectedVariant?.id ||
      document.querySelector('[name="id"]')?.value;

    renderPickupSection(initialVariantId);
  });
})();
